import { create } from 'zustand';

type SimulatorForm = {
  valor_inmueble: string;
  enganche: string;
  preventa: string;
  presupuesto_mensual: string;
  plazo: string;
  nombre: string;
  telefono: string;
  correo: string;
};

type OTP = {
  code: string;
  attempts: number;
  correct?: boolean;
};

type SimulatorStore = {
  form?: SimulatorForm;
  phone_otp?: OTP;
  email_otp?: OTP;
  saveQuote: (form: Partial<SimulatorForm>) => void;
  saveClientData: (form: Partial<SimulatorForm>) => void;
  saveClientDataMail: (form: Partial<SimulatorForm>) => void;
  savePhoneOTP: (otp: OTP) => void;
  saveEmailOTP: (otp: OTP) => void;
  reset: () => void;
};

export const useSimulatorStore = create<SimulatorStore>(set => ({
  form: undefined,
  phone_otp: undefined,
  email_otp: undefined,
  saveQuote: (form: Partial<SimulatorForm>) =>
    set(state => ({ form: { ...state.form, ...form } as SimulatorForm })),
  saveClientData: (form: Partial<SimulatorForm>) =>
    set(state => ({ form: { ...state.form, ...form } as SimulatorForm })),
  saveClientDataMail: (form: Partial<SimulatorForm>) =>
    set(state => ({ form: { ...state.form, ...form } as SimulatorForm })),
  savePhoneOTP: (otp: OTP) => set({ phone_otp: otp }),
  saveEmailOTP: (otp: OTP) => set({ email_otp: otp }),
  reset: () =>
    set({ form: undefined, phone_otp: undefined, email_otp: undefined }),
}));
